<a href="javascript:;" (click)="downloadFile()">{{
  'Conversation::ClickHereToDownloadReport' | abpLocalization
}}</a>
